import React, { useState, useEffect } from "react";
import axios from "axios";
import Nav from "../../components/Home/Nav";
import Footer from "../../components/Home/Footer";
import SignificantProjects from "../../components/Home/SignificantProjects";
import NotableProjects from "../../components/Home/NotableProjects";
import ConstructionPartners from "../../components/Home/ConstructionPartners";
import {
  HiCollection,
  HiOutlineCube,
  HiCheckCircle,
  HiArrowRight,
} from "react-icons/hi";

function Portfolio() {
  const [portfolios, setPortfolios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPortfolios = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || `${process.env.REACT_APP_API_URL || "http://localhost:5000"}`}/api/portfolios`,
        );
        setPortfolios(response.data || []);
      } catch (error) {
        console.error("Error fetching portfolios:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPortfolios();
  }, []);

  const notableProjects = portfolios.filter((p) => p.category === "notable");
  const significantProjects = portfolios.filter(
    (p) => p.category === "significant",
  );
  const partners = portfolios.filter((p) => p.category === "partner");
  return (
    <div className="bg-slate-50 min-h-screen">
      <Nav />

      {/* Notable Projects Section */}
      <section className="bg-white border-y border-slate-100 py-32 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 mb-16">
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4 tracking-tighter">
              Notable <span className="text-blue-600">Projects</span>
            </h2>
            <p className="text-slate-500 font-medium">
              Major milestones in building AI and data solutions that matter
            </p>
          </div>
        </div>
        <NotableProjects projects={notableProjects} />
      </section>

      {/* Significant Projects Section */}
      <section className="py-16 md:py-32 bg-slate-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 mb-12 md:mb-16 text-center md:text-right">
          <div className="max-w-xl md:ml-auto">
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4 tracking-tighter">
              Other <span className="text-blue-600">Projects</span>
            </h2>
            <p className="text-slate-500 font-medium text-sm md:text-base">
              A problem solver who build solutions
            </p>
          </div>
        </div>
        <SignificantProjects projects={significantProjects} />
      </section>

      {/* Contact CTA */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 pb-24 md:pb-32">
        <div className="bg-slate-900 rounded-[2rem] md:rounded-[3rem] p-8 md:p-24 text-white relative overflow-hidden group shadow-2xl">
          <div className="absolute inset-0 bg-blue-600/10 skew-x-12 translate-x-64 group-hover:translate-x-32 transition-transform duration-1000"></div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-12 text-center lg:text-left">
            <div className="max-w-2xl">
              <h2 className="text-3xl md:text-6xl font-black mb-4 md:mb-8 leading-tight tracking-tight">
                Ready to connect?
              </h2>
            </div>
            <a
              href="/contact"
              className="shrink-0 px-8 py-5 md:px-12 md:py-6 bg-blue-600 text-white rounded-[1.5rem] md:rounded-[2rem] font-black uppercase tracking-widest text-[10px] hover:bg-white hover:text-blue-600 transition-all shadow-2xl shadow-blue-500/20 active:scale-95 flex items-center gap-3"
            >
              Get Integrated <HiArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Portfolio;
